import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const FIELDS = [
  ["stripe_payment_intent_id", "Payment Intent ID", "payment-intent-id"],
  ["stripe_charge_id", "Charge ID", "charge-id"],
  ["stripe_invoice_id", "Invoice ID", "invoice-id"],
  ["stripe_invoice_number", "Invoice Number", "invoice-number"],
];

export const OrderPaymentReferences = ({ order }) => {
  const [values, setValues] = useState(order);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setValues(order);
    setLoading(true);
    setFailed(false);
    const load = async () => {
      try {
        const { data } = await api.get(`/orders/${order.id}/payment-references`);
        if (active) { setValues(data); setFailed(false); }
      } catch {
        if (active) setFailed(true);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    window.addEventListener("focus", load);
    return () => { active = false; window.removeEventListener("focus", load); };
  }, [order]);

  return (
    <section className="border-y border-[var(--border)] py-3" data-testid="order-payment-references" aria-label="Payment references" aria-busy={loading}>
      <h3 className="text-xs font-semibold mb-3" data-testid="payment-references-heading">Payment references</h3>
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-3">
        {FIELDS.map(([field, label, testId]) => (
          <div key={field} className="min-w-0">
            <dt className="text-xs text-gray-500" data-testid={`order-${testId}-label`}>{label}</dt>
            <dd className="mt-1 text-xs font-mono break-all select-text" data-testid={`order-${testId}`}>
              {values[field] || (loading ? "Loading…" : "Not available")}
            </dd>
          </div>
        ))}
      </dl>
      {failed && <p role="status" className="mt-2 text-xs text-amber-700" data-testid="payment-references-error">Payment references could not be refreshed.</p>}
    </section>
  );
};